import React from 'react'
import { tipiOperazioneAmmessi } from '../../lib/validazioni'

export default function StepTipoOperazione({ data, update, ruoloUtente }) {
  const tipiVisibili = tipiOperazioneAmmessi(ruoloUtente)
  const isSubagente = ruoloUtente === 'subagente'

  return (
    <div>
      <div className="info-box mt-1" style={{ marginBottom: '1.5rem' }}>
        Seleziona il tipo di pratica da emettere. La scelta determina quali compagnie e durate sono disponibili
        nei passaggi successivi.
      </div>

      <div className="comp-grid">
        {tipiVisibili.map(t => (
          <div key={t.value}
               className={`comp-card ${data.tipo_operazione === t.value ? 'selected' : ''}`}
               onClick={() => update({ tipo_operazione: t.value })}
               style={{ cursor: 'pointer' }}>
            <div className="comp-name">{t.label}</div>
            <div className="text-small text-muted">{t.desc}</div>
          </div>
        ))}
      </div>

      {isSubagente && (
        <div className="info-box mt-3">
          Sei registrato come <strong>subagente</strong>: puoi emettere polizze annuali (12 mesi),
          polizze autocarri intermediari e garanzie stand alone (durata 1 anno).
        </div>
      )}
    </div>
  )
}

